import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ExperimentOutlined, FileTextOutlined, MedicineBoxOutlined, RightOutlined, ScheduleOutlined, UserOutlined } from '@ant-design/icons';
import PatientLogHeader from './PatientLogHeader';
import localeTranslator from 'library/Hocs/LocalTranslator';
import 'pages/ShowAppointment/components/PatientLog/style.css';
var PatientLogEntities = function (props) {
    var _a, _b, _c, _d, _e;
    var t = props.translate;
    var badge = props.patientName && (props.patientCode || props.appointmentId)
        ? "".concat(props.patientName, " \u00B7 #").concat(props.appointmentId || props.patientCode)
        : props.patientName;
    var items = [
        {
            key: 'prescriptions',
            title: t('prescriptions.title'),
            description: t('menu.prescriptionsDesc'),
            icon: _jsx(MedicineBoxOutlined, {}),
            onClick: function () { return props.setShowPrescriptions(true); },
            count: (_a = props.counts) === null || _a === void 0 ? void 0 : _a.prescriptions,
            countLabel: ((_b = props.counts) === null || _b === void 0 ? void 0 : _b.prescriptions) != null
                ? t('menu.activeCount', { count: props.counts.prescriptions })
                : undefined,
            onboarding: 'patient-log-prescriptions-link'
        },
        {
            key: 'diagnoses',
            title: t('diagnoses.title'),
            description: t('menu.diagnosesDesc'),
            icon: _jsx(FileTextOutlined, {}),
            onClick: function () { return props.setShowDiagnoses(true); },
            count: (_c = props.counts) === null || _c === void 0 ? void 0 : _c.diagnoses,
            onboarding: 'patient-log-diagnoses-link'
        },
        {
            key: 'followUps',
            title: t('followUps.title'),
            description: t('menu.followUpsDesc'),
            icon: _jsx(ScheduleOutlined, {}),
            onClick: function () { return props.setShowFollowUps(true); },
            count: (_d = props.counts) === null || _d === void 0 ? void 0 : _d.followUps,
            onboarding: 'patient-log-follow-ups-link'
        },
        {
            key: 'medicalTests',
            title: t('medicalTests.title'),
            description: t('menu.medicalTestsDesc'),
            icon: _jsx(ExperimentOutlined, {}),
            onClick: function () { return props.setShowMedicalTests(true); },
            count: (_e = props.counts) === null || _e === void 0 ? void 0 : _e.medicalTests,
            onboarding: 'patient-log-medical-tests-link'
        },
        {
            key: 'patientDetails',
            title: t('patientDetails.title'),
            description: t('menu.patientDetailsDesc'),
            icon: _jsx(UserOutlined, {}),
            onClick: function () { return props.setShowPatientMedicalDetails(true); },
            mutedIcon: true,
            onboarding: 'patient-log-patient-details-link'
        }
    ];
    return (_jsxs("div", { className: "patient-log", "data-onboarding": "patient-log-entities", children: [_jsx(PatientLogHeader, { title: t('title'), subtitle: t('menu.subtitle'), badge: badge, hasAddButton: false, hasBackButton: false, hasCloseButton: true, onClose: props.onClose }), _jsx("div", { className: "patient-log__body", children: _jsx("div", { className: "patient-log-menu", children: items.map(function (item) { return (_jsxs("div", { className: "patient-log-entity-row", onClick: item.onClick, "data-onboarding": item.onboarding, role: "button", tabIndex: 0, onKeyDown: function (event) {
                            if (event.key === 'Enter' || event.key === ' ')
                                item.onClick();
                        }, children: [_jsxs("div", { className: "patient-log-entity-row__left", children: [_jsx("div", { className: "patient-log-entity-row__icon".concat(item.mutedIcon ? ' is-muted' : ''), children: item.icon }), _jsxs("div", { className: "patient-log-entity-row__text", children: [_jsxs("div", { className: "patient-log-entity-row__title-row", children: [_jsx("span", { className: "patient-log-entity-row__title", children: item.title }), item.count != null && item.count > 0 && (_jsx("span", { className: "patient-log-entity-row__count".concat(item.countTone === 'pending' ? ' is-pending' : ''), children: item.countLabel || item.count }))] }), _jsx("p", { className: "patient-log-entity-row__desc", children: item.description })] })] }), _jsx("span", { className: "patient-log-entity-row__chevron", children: props.arrowIcon || _jsx(RightOutlined, {}) })] }, item.key)); }) }) }), _jsxs("footer", { className: "patient-log__footer", children: [_jsxs("div", { className: "patient-log__sync", children: [_jsx("span", { className: "patient-log__sync-dot" }), _jsx("span", { children: t('menu.synced') })] }), _jsx("button", { type: "button", className: "patient-log-header__btn patient-log-header__btn--ghost", onClick: props.onClose, children: t('menu.closeDrawer') })] })] }));
};
export default localeTranslator(PatientLogEntities, 'patientLog');
